import { useEffect } from "react";
import styles from "./ProgressBar.module.css";

type ProgressBarProps = {
  total: number;
  current: number;
};

export default function ProgressBar(props: ProgressBarProps) {
  const percentage = Math.max((props.current / props.total) * 100 - 0.5, 0);

  return (
    <div className={styles.main}>
      <div style={{ width: `${percentage}%` }} className={styles.inner}></div>
    </div>
  );
}
